module.exports = __webpack_public_path__ + "static/media/wizualizacja-143.4a94c78e.png";